import React from 'react'
import { createSearchURLParams, get_bulk_settings } from '../../../Component/Helper';
import { Link } from 'react-router-dom';

export default function My_Catalogue_New_Arrival_Card({catalogue_name, product_count, image, id}) {
   const { cdn, default_image, my_catalogue_push_to } =
       get_bulk_settings(["cdn", "default_image", "my_catalogue_push_to"]) || {}; 

  const default_image_url = `${cdn}uploads/default_image/${default_image}`

  const img_url = (image.toLowerCase().includes(".jpg") ||  image.toLowerCase().includes(".png")) ? image : default_image_url
  const is_subcategory = my_catalogue_push_to === "Category-Subcategory"

  const myc_new_arrival_redirection = () => {
        if(is_subcategory){
            return {to: createSearchURLParams("myc-categories", {catalogue_id: id}), state: {cat_name: catalogue_name, product_count: product_count}}
        }else{
            return {to: createSearchURLParams('matrix-page', {catalogue_id: id, mode: 'catalogue_filter'}), state: {cat_name: catalogue_name, product_count: product_count}}
        }
  }

  return (
    <Link className='my-catalougue-new-arrival-card' {...myc_new_arrival_redirection()}>
      <div className='image-container'>
        <img src={img_url} alt={catalogue_name} 
        />
      </div>
      <div className='details-container'>
        <h3>{catalogue_name}</h3>
        <p>{product_count} Product(s)</p>
      </div>
    </Link>
  )
}
